<script lang="tsx">
import { defineComponent } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { AuthLink, authLinkProps } from '-/Common/AuthLink'

const [name] = createNamespace('NameIdDisplay')
export default defineComponent({
  name,
  props: {
    // 名称
    title: {
      type: [String, Number],
      default: ''
    },
    // ID
    id: {
      type: [String, Number],
      default: ''
    },
    ...authLinkProps
  },
  setup(props) {
    return () => (
      <div>
        <AuthLink permission={props.permission} name={props.name} to={props.to} blank={props.blank} title={props.title}>
          {props.title}
        </AuthLink>
        <div>{props.id}</div>
      </div>
    )
  }
})
</script>
